var _jsxFileName = "/builds/experiences/errors-ui/src/UnexpectedErrorMessage.js";
import React from 'react';
import PropTypes from 'prop-types';
var styles = {
  "wrapper": "errors-ui__UnexpectedErrorMessage__wrapper___2QVEx"
}; // eslint-disable-next-line react/display-name

function renderCustomError(customError) {
  return typeof customError === 'string' ? React.createElement("p", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: this
  }, customError) : customError;
}
export default function UnexpectedErrorMessage(_ref) {
  var className = _ref.className,
    action = _ref.action,
    children = _ref.children;
  return React.createElement("div", {
    className: className ? "".concat(styles.wrapper, " ").concat(className) : styles.wrapper,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  }, children ? renderCustomError(children) : React.createElement(React.Fragment, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: this
  }, React.createElement("p", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: this
  }, "We're sorry, we've encountered an unexpected error", action ? " ".concat(action) : '', "."), React.createElement("p", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  }, "We are working hard to fix the problem and hope to have it resolved shortly.")));
}
UnexpectedErrorMessage.propTypes = {
  className: PropTypes.string,
  action: PropTypes.string,
  children: PropTypes.node
};
UnexpectedErrorMessage.displayName = 'UnexpectedErrorMessage';